import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-branding',
  template: `
   <div class="branding">
  <a href="/dashboard">
    <img
      *ngIf="!collapsed"
      [src]="brandinglogopath"
      class="branding-logo"
      (error)="setDefaultImage($event)"
    />

    <img
      *ngIf="collapsed"
      [src]="brandinglogopath"
      class="branding-avatar"
    />
  </a>
</div>
  `,
  styles: [
    `
      .branding {
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s ease;
      }

      // .branding a {
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      //   text-decoration: none;
      // }

      /* Expanded Sidebar Logo */
      .branding-logo {
        width: 155px;
        height: 70px;
        object-fit: contain;
        transition: all 0.3s ease;
        margin-top:4px;
      }

      /* Collapsed Sidebar Logo */
      .branding-avatar {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        object-fit: contain;
        background: #fff;
        border: 1px solid #dcdcdc;
        padding: 4px;
        transition: all 0.3s ease;
      }
    `,
  ],
})
export class BrandingComponent implements OnInit {
  @Input() collapsed = false;

  brandinglogopath: string =
    '../../../../assets/images/logos/lll.png';

  constructor(public apiService: ApiService) {}

  ngOnInit(): void {
    const storedImage = sessionStorage.getItem('profileImage');
    const storedLogo = sessionStorage.getItem('brandinglogopath');

    if (storedImage) {
      this.brandinglogopath = storedImage;
    } else if (storedLogo) {
      this.brandinglogopath = storedLogo;
    }
  }

  setDefaultImage(event: any) {
    event.target.src =
      '../../../../assets/images/logos/image-removebg-preview.jpg';
  }
}